module.exports = __webpack_public_path__ + "img/solution-data-logo11.6a4a6113.png";